"use strict";function openAccountPwdLoginPage$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openAccountPwdLoginPage$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.auth.openAccountPwdLoginPage";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.0"},_a)),exports.openAccountPwdLoginPage$=openAccountPwdLoginPage$,exports.default=openAccountPwdLoginPage$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/auth/openAccountPwdLoginPage.js
// module id = 908
// module chunks = 106